/*
 *   File : video-card.js
 *   Author : https://evoqins.com
 *   Description : Video cards component
 *   Integrations : NA
 *   Version : 1.0.0
*/

import React, { useState } from 'react'

import Icon from '../Icon/icon';

function VideoCard({ data, handleClickVideo }) {

    const [objectFitClass, setObjectFitClass] = useState("object-fit-cover");

    const _handleImageLoad = (e) => {
        const { naturalWidth, naturalHeight } = e.currentTarget;
        setObjectFitClass(naturalWidth >= naturalHeight ? "object-fit-fill" : "object-fit-cover");
    };

    return (
        <div className="d-flex flex-column e-border-1px-lavender e-border-radius-16 overflow-hidden cursor-pointer  card-hover h-100"
            onClick={handleClickVideo}>
            <div className="video-wrapper position-relative">
                <img
                    src={data.thumbnail}
                    className={`w-100 home-video-card-img ${objectFitClass}`}
                    alt="video thumbnail"
                    draggable="false"
                    onLoad={_handleImageLoad}
                />
                <span className="video-ply-btn p-1">
                    <Icon icon="video-play-btn" size={16} className="" />
                    <span className="e-text-dark-jet e-font-10 e-alt-font-poppins e-font-weight-400 line-height-14px">
                        {data.duration}
                    </span>
                </span>
            </div>

            <div className="padding-12px-all e-light-bluish-white">
                <h5 className="e-text-dark-jet e-font-12-res e-font-16 e-alt-font-poppins e-font-weight-500 line-height-20px margin-12px-bottom">
                    {data.title}
                </h5>
                <p className="e-text-dark-jet e-font-12-res e-font-14 e-alt-font-poppins e-font-weight-500 line-height-14px margin-2px-bottom">
                    {data.speaker_name}
                </p>
                <p className="e-text-dark-jet  e-font-12 e-alt-font-poppins e-font-weight-400 line-height-14px mb-0">
                    {data.designation}
                </p>
            </div>
        </div>
    );

}

export default VideoCard